__turbopack_context__.v({
  "actions": "globalWaitlistWidget-module-scss-module__1uuJEW__actions",
  "actionsHint": "globalWaitlistWidget-module-scss-module__1uuJEW__actionsHint",
  "alreadyOnWaitlist": "globalWaitlistWidget-module-scss-module__1uuJEW__alreadyOnWaitlist",
  "card": "globalWaitlistWidget-module-scss-module__1uuJEW__card",
  "charCount": "globalWaitlistWidget-module-scss-module__1uuJEW__charCount",
  "description": "globalWaitlistWidget-module-scss-module__1uuJEW__description",
  "disclaimer": "globalWaitlistWidget-module-scss-module__1uuJEW__disclaimer",
  "divider": "globalWaitlistWidget-module-scss-module__1uuJEW__divider",
  "dockBar": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBar",
  "dockBarChevron": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBarChevron",
  "dockBarHidden": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBarHidden",
  "dockBarIcon": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBarIcon",
  "dockBarLabel": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBarLabel",
  "dockBarReady": "globalWaitlistWidget-module-scss-module__1uuJEW__dockBarReady",
  "feedback": "globalWaitlistWidget-module-scss-module__1uuJEW__feedback",
  "feedbackError": "globalWaitlistWidget-module-scss-module__1uuJEW__feedbackError",
  "feedbackSuccess": "globalWaitlistWidget-module-scss-module__1uuJEW__feedbackSuccess",
  "field": "globalWaitlistWidget-module-scss-module__1uuJEW__field",
  "fieldError": "globalWaitlistWidget-module-scss-module__1uuJEW__fieldError",
  "fieldHint": "globalWaitlistWidget-module-scss-module__1uuJEW__fieldHint",
  "form": "globalWaitlistWidget-module-scss-module__1uuJEW__form",
  "inputError": "globalWaitlistWidget-module-scss-module__1uuJEW__inputError",
  "inputReadOnly": "globalWaitlistWidget-module-scss-module__1uuJEW__inputReadOnly",
  "introCatchphrase": "globalWaitlistWidget-module-scss-module__1uuJEW__introCatchphrase",
  "introIcons": "globalWaitlistWidget-module-scss-module__1uuJEW__introIcons",
  "marketingOptIn": "globalWaitlistWidget-module-scss-module__1uuJEW__marketingOptIn",
  "marketingOptInText": "globalWaitlistWidget-module-scss-module__1uuJEW__marketingOptInText",
  "minimizeButton": "globalWaitlistWidget-module-scss-module__1uuJEW__minimizeButton",
  "optionalLabel": "globalWaitlistWidget-module-scss-module__1uuJEW__optionalLabel",
  "panel": "globalWaitlistWidget-module-scss-module__1uuJEW__panel",
  "panelExpanded": "globalWaitlistWidget-module-scss-module__1uuJEW__panelExpanded",
  "requiredAsterisk": "globalWaitlistWidget-module-scss-module__1uuJEW__requiredAsterisk",
  "rowSplit": "globalWaitlistWidget-module-scss-module__1uuJEW__rowSplit",
  "smsConsent": "globalWaitlistWidget-module-scss-module__1uuJEW__smsConsent",
  "subtitle": "globalWaitlistWidget-module-scss-module__1uuJEW__subtitle",
  "subtitleLabel": "globalWaitlistWidget-module-scss-module__1uuJEW__subtitleLabel",
  "successHeading": "globalWaitlistWidget-module-scss-module__1uuJEW__successHeading",
  "successIcon": "globalWaitlistWidget-module-scss-module__1uuJEW__successIcon",
  "successNextDescription": "globalWaitlistWidget-module-scss-module__1uuJEW__successNextDescription",
  "successNextLabel": "globalWaitlistWidget-module-scss-module__1uuJEW__successNextLabel",
  "successSubtext": "globalWaitlistWidget-module-scss-module__1uuJEW__successSubtext",
  "successView": "globalWaitlistWidget-module-scss-module__1uuJEW__successView",
  "title": "globalWaitlistWidget-module-scss-module__1uuJEW__title",
  "waitlistPanelIn": "globalWaitlistWidget-module-scss-module__1uuJEW__waitlistPanelIn",
  "widget": "globalWaitlistWidget-module-scss-module__1uuJEW__widget",
});
